import React, { useState, useEffect, useContext } from 'react';
import { OutlinedInput, Select, MenuItem, Divider } from '@material-ui/core';
import Format from '../../../Utils/formatCurrent';
import ModalBanner from '../../ModalBanner';
import ModalCardPaymentResult from '../ModalCardPaymentResult';
import {
  Title,
  ModalWrapper,
  ValueSectionWrapper,
  BodyWrapper,
  FooterWrapper,
} from './styled';

import { ButtonPrimary, Spinner } from '../../StyledComponent';
import Close from '../../Reutilizaveis/CloseButton';
import ReCAPTCHA from 'react-google-recaptcha';
import CardParcelasSelecionadas from '../GerarBoleto/ParcelasSelecionadas/CardParcelasSelecionadas';
import { maskCard, maskDate, maskNumber, maskName } from '../../../Utils/masks';
import { ContextPagamentoCartao } from '../../../services/pagamentoCartao';
import cardValidator from 'card-validator';
import { ReactComponent as AmexIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/amex.svg';
import { ReactComponent as VisaIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/visa.svg';
import { ReactComponent as MastercardIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/mastercard.svg';
import { ReactComponent as EloIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/elo.svg';
import { ReactComponent as DinersIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/diners-club.svg';
import { ReactComponent as HipercardIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/hipercard.svg';
import { ReactComponent as DiscoverIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/discover.svg';
import { ReactComponent as UnionPayIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/unionpay.svg';
import { ReactComponent as JCBIcon } from '../../../assets/novosicones/Financeiro/CartaoCredito/jcb.svg';

import { totalParcelasSelecionadas } from '../ParcelasAPagar/functionsParcelasAPagar';
import { useHistory } from 'react-router-dom';

const CardPayment = ({ tema, getParcelas, setParcelasSelecionadas }) => {
  const { handleOpenModalCardPayment, postPagarCartao, parcelasCardPayment } =
    useContext(ContextPagamentoCartao);
  const [total, setTotal] = useState(0);
  const [maxQntParcelas, setMaxQntParcelas] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [parcelas, setParcelas] = useState(1);
  const [infosCardValidation, setInfosCardValidation] = useState({});
  const [cardNumber, setCardNumber] = useState('');
  const [cardType, setCardType] = useState('credito');
  const [expirationDate, setExpirationDate] = useState('');
  const [CVV, setCVV] = useState('');
  const [name, setName] = useState('');
  const [recaptcha, setRecaptcha] = useState(null);
  const [success, setSuccess] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);

  const initialValidState = {
    cardNumber: 'untouched',
    CVV: 'untouched',
    expirationDate: 'untouched',
    name: 'untouched',
    recaptcha: 'untouched',
  };
  const [valid, setValid] = useState(initialValidState);

  const history = useHistory();

  const handleSubmit = () => {
    (async function () {
      try {
        setIsLoading(true);
        await postPagarCartao({
          parcelas: parcelasCardPayment.map((p) => ({
            ...p.parcela,
            grupoExpandido: [],
          })),
          cartao: {
            tipo: cardType === 'credito' ? 1 : 0,
            numeroCartao: cardNumber.replaceAll(' ', ''),
            nomeCartao: name,
            mesExpiracao: Number(expirationDate.split('/')[0]),
            anoExpiracao: Number(expirationDate.split('/')[1]),
            codigoSeguranca: CVV,
          },
          qtdeParcelas: Number(parcelas),
        });
        setSuccess(true);
        handleOpenResultModal();
        setParcelasSelecionadas([]);
      } catch (e) {
        clearData();
        setSuccess(false);
        handleOpenResultModal();
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    })();
  };

  const clearData = () => {
    setParcelas(1);
    setInfosCardValidation({});
    setCardNumber('');
    setCardType('credito');
    setCVV('');
    setExpirationDate('');
    setName('');
    setRecaptcha(null);
    setValid(initialValidState);
  };
  const verifyInvalidField = () => {
    const values = Object.values(valid);

    const invalidFields = values.filter((v) => !v || v === 'untouched');

    return invalidFields?.length > 0;
  };

  const closePaymentModal = () => {
    handleOpenModalCardPayment();
  };

  function handleSetValueCard(e) {
    const maxLength = infosCardValidation?.card?.lengths
      ? Math.max(...infosCardValidation.card.lengths)
      : 16;
    const value = maskCard(e.target.value, setCardNumber, maxLength);

    if (value?.length === 4 || value?.length === maxLength) {
      validateCardNumber(value);
    }
  }

  function validateCardNumber(value) {
    if (!(typeof value === 'string')) {
      value = value?.target?.value;
    }

    const cardValidation = cardValidator.number(value?.replaceAll(' ', ''));
    setInfosCardValidation(cardValidation);
    setValid({
      ...valid,
      cardNumber: cardValidation.isValid && cardValidation?.isPotentiallyValid,
    });
  }

  function handleExpirationDate(e) {
    maskDate(e.target.value, setExpirationDate);
  }

  function validateExpirationDate(e) {
    const value = e.target.value;
    const { isValid: expirationDate } = cardValidator.expirationDate(value);
    setValid({ ...valid, expirationDate });
  }

  function handleCVV(e) {
    maskNumber(
      e.target.value,
      infosCardValidation?.card?.code?.size || 3,
      setCVV
    );
  }

  function validateCVV(e) {
    const value = e.target.value;
    const { isValid: CVV } = cardValidator.cvv(
      value,
      infosCardValidation?.card?.code?.size || 3
    );
    setValid({ ...valid, CVV });
  }

  function handleRecaptchaValue(value) {
    setRecaptcha(value);

    setValid({ ...valid, recaptcha: value });
  }

  function handleName(e) {
    const value = e.target.value;
    maskName(value, setName);
  }

  function validateName(e) {
    const value = e.target.value;
    const { isValid: name } = cardValidator.cardholderName(value);

    setValid({ ...valid, name });
  }

  function handleOpenResultModal() {
    setOpenResultModal(!openResultModal);
  }

  useEffect(() => {
    history.replace('/financeiro/#modal-cartao-credito');

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
      history.replace('/financeiro');
    };
  }, []);

  useEffect(() => {
    setTotal(totalParcelasSelecionadas(parcelasCardPayment));
  }, [parcelasCardPayment]);

  useEffect(() => {
    let qntParcelas = Math.trunc(Number(total / 150));
    if (qntParcelas > 12) {
      qntParcelas = 12;
    }

    setMaxQntParcelas(qntParcelas);
  }, [total]);

  function handleCardCreditIcon() {
    switch (infosCardValidation?.card?.type) {
      case 'mastercard':
        return <MastercardIcon />;
      case 'american-express':
        return <AmexIcon />;
      case 'visa':
        return <VisaIcon />;
      case 'elo':
        return <EloIcon />;
      case 'diners-club':
        return <DinersIcon />;
      case 'hipercard':
        return <HipercardIcon />;
      case 'discover':
        return <DiscoverIcon />;
      case 'unionpay':
        return <UnionPayIcon />;
      case 'jcb':
        return <JCBIcon />;
      default:
        break;
    }
  }

  return (
    <ModalBanner showBanner={parcelasCardPayment?.length > 0} zIndex='20000'>
      {!openResultModal && (
        <ModalWrapper>
          <div>
            <Title tema={tema}>
              Pagamento por cartão de crédito
              <span onClick={closePaymentModal}>
                <Close
                  tamanho='32px'
                  tamanhoIcone='22px'
                  corBackground='#fff'
                  borderColor='#B61817'
                  marginRight={0}
                />
              </span>
            </Title>
          </div>

          <BodyWrapper>
            <span style={{ display: 'block', marginBottom: 8 }}>Resumo:</span>
            <div>
              {parcelasCardPayment?.length > 0 &&
                !parcelasCardPayment[0]?.parcela?.temBoleto &&
                parcelasCardPayment?.map((parcela) => (
                  <CardParcelasSelecionadas
                    key={parcela?.numeroParcelaGeral}
                    parcela={parcela}
                    tema={tema}
                  />
                ))}
              {parcelasCardPayment?.length > 0 &&
                parcelasCardPayment[0]?.parcela?.temBoleto && (
                  <CardParcelasSelecionadas
                    key={parcelas?.numeroParcelaGeral}
                    parcela={parcelasCardPayment[0]}
                    tema={tema}
                  />
                )}
            </div>
            <Divider style={{ height: 2, marginTop: 32, marginBottom: 16 }} />
            <label>
              <span>Número do cartão:</span>

              <OutlinedInput
                placeholder='0000 0000 0000 0000'
                fullWidth
                value={cardNumber}
                className='inputStyle'
                onChange={handleSetValueCard}
                onBlur={validateCardNumber}
                error={valid?.cardNumber !== 'untouched' && !valid?.cardNumber}
                endAdornment={handleCardCreditIcon()}
                id={'inputNumeroCartaoCredito'}
              />
            </label>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 24,
              }}
            >
              <label>
                <span>Validade</span>
                <OutlinedInput
                  placeholder='00/00'
                  fullWidth
                  value={expirationDate}
                  onChange={handleExpirationDate}
                  onBlur={validateExpirationDate}
                  error={
                    valid.expirationDate !== 'untouched' &&
                    !valid.expirationDate
                  }
                  className='inputStyle'
                  id={'inputValidadeCartaoCredito'}
                />
              </label>
              <label>
                <span>CVV</span>
                <OutlinedInput
                  placeholder='000'
                  value={CVV}
                  onChange={handleCVV}
                  error={valid.CVV !== 'untouched' && !valid.CVV}
                  onBlur={validateCVV}
                  fullWidth
                  className='inputStyle'
                  id={'inputCVV'}
                />
              </label>
            </div>
            <label>
              <span>Nome completo:</span>
              <OutlinedInput
                placeholder='Como está impresso no cartão'
                value={name}
                onChange={handleName}
                fullWidth
                error={valid.name !== 'untouched' && !valid.name}
                onBlur={validateName}
                className='inputStyle'
                id={'inputNomeCompleto'}
              />
            </label>
            <label>
              <span>Forma de pagamento</span>
              <Select
                placeholder='Selecione a quantidade de parcelas'
                variant='outlined'
                value={parcelas}
                onChange={(e) => setParcelas(e.target.value)}
                fullWidth
                className='inputStyle'
                id={'selectNumeroParcelas'}
              >
                <MenuItem value='none' disabled>
                  Selecione as parcelas
                </MenuItem>
                <MenuItem value='1'>A vista - {Format(total)}</MenuItem>
                {maxQntParcelas > 0 &&
                  [...new Array(maxQntParcelas - 1)].map((value, index) => {
                    return (
                      <MenuItem
                        key={index + 2}
                        value={index + 2}
                        style={{
                          display: cardType === 'debito' ? 'none' : 'block',
                        }}
                      >
                        {index + 2}x sem juros de{' '}
                        {Format((total / (index + 2)).toFixed(2))}{' '}
                      </MenuItem>
                    );
                  })}
              </Select>
            </label>
          </BodyWrapper>
          <FooterWrapper>
            <ValueSectionWrapper tema={tema}>
              <ReCAPTCHA
                sitekey={'6LeSYNQjAAAAACqrmY5CWFvebP-TlEkeoWpK3Nlf'}
                onChange={handleRecaptchaValue}
                defaultValue={recaptcha}
                className='recaptcha'
                data-hj-allow-iframe
              />
              <div>
                <span className='totalLabel'>Total:</span>
                <span className='totalValue'>{Format(total)}</span>

                <span className='portion'>
                  {parcelas === 1 && <span>em 1x no cartão sem juros</span>}
                  {parcelas !== 1 && (
                    <span>
                      em {parcelas}x sem juros de{' '}
                      {Format((total / Number(parcelas)).toFixed(2))}
                    </span>
                  )}
                </span>
              </div>
            </ValueSectionWrapper>
            <ButtonPrimary
              fullWidth
              tema={tema}
              onClick={handleSubmit}
              disabled={verifyInvalidField() || isLoading}
            >
              <span>Finalizar Pagamento</span>
              {isLoading && <Spinner />}
            </ButtonPrimary>
          </FooterWrapper>
        </ModalWrapper>
      )}
      {openResultModal && (
        <ModalCardPaymentResult
          getParcelas={getParcelas}
          tema={tema}
          close={handleOpenModalCardPayment}
          error={!success}
          tryAgain={handleOpenResultModal}
        />
      )}
    </ModalBanner>
  );
};

export default CardPayment;
